import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Footer from '@/container/Footer';
import HeaderWrapper from '@/container/Header/HeaderWrapper';
import { isCanUseProffitSearch, isClient, isProfessional } from '@/helpers/auth';
import { propBool, propChildren, propFunc, propOneOf, propStr, } from '@/helpers/custom-prop-types';
import MaintenanceLayout from './Maintenance';
const Layout = (props) => {
    const { bottomContent, children, footerClassName, guestHeaderViewMode, headerClassName, headerType, isHideHelp, isLoading, mainClassName, onChangeKeyword, onChangeSearch, onClickGuestHeaderMenu, onSubmitSearch, renderStickyComponent, showFooter, showHeader, showProffitSearchLink: rawShowProffitSearchLink, showSearch, sticky, stickyClassName, type, } = props;
    const auth = useSelector((state) => state.auth);
    const profile = useSelector((state) => state.profile);
    const location = useLocation();
    const showHelp = useMemo(() => {
        const showUser = isClient(auth) || isProfessional(auth);
        return !isHideHelp && !isLoading && showUser && headerType !== 'top';
    }, [isLoading, auth, headerType, isHideHelp]);
    /**
     * クライアントユーザーで、Proffit Searchの権限を持っている、かつProffit Searchのルート外の場合にリンクを表示する
     * @type {boolean}
     */
    const showProffitSearchLink = useMemo(() => {
        const path = location.pathname.replace(/\/$/, '');
        return (rawShowProffitSearchLink &&
            isClient(auth) &&
            isCanUseProffitSearch(profile) &&
            path.indexOf('/proffit_search') < 0);
    }, [rawShowProffitSearchLink, profile, auth, location.pathname]);
    if (type === 'maintenance') {
        return _jsx(MaintenanceLayout, { children: children });
    }
    return (_jsxs(_Fragment, { children: [_jsx(HeaderWrapper, { guestHeaderViewMode: guestHeaderViewMode, headerClassName: headerClassName, headerType: headerType, onChangeKeyword: onChangeKeyword, onChangeSearch: onChangeSearch, onClickGuestHeaderMenu: onClickGuestHeaderMenu, onSubmitSearch: onSubmitSearch, showHeader: showHeader, showSearch: showSearch }), _jsx("main", Object.assign({ className: clsx(mainClassName, (showHelp ||
                    showSearch ||
                    showProffitSearchLink ||
                    sticky ||
                    renderStickyComponent) &&
                    'has-sticky-footer', showProffitSearchLink && 'is-show-proffit-search-link') }, { children: children })), showFooter && (_jsx(Footer, Object.assign({ bottomContent: bottomContent, footerClassName: footerClassName, isLoading: isLoading, renderStickyComponent: renderStickyComponent, showHelp: showHelp, showProffitSearchLink: showProffitSearchLink, stickyClassName: stickyClassName }, { children: sticky })))] }));
};
Layout.propTypes = {
    bottomContent: propChildren(),
    children: propChildren().isRequired,
    footerClassName: propStr(),
    guestHeaderViewMode: propOneOf(['normal', 'expand']),
    headerClassName: propStr(),
    headerType: propOneOf(['top', 'search', 'proffit_search', 'default', 'none']),
    isHideHelp: propBool(),
    isLoading: propBool(),
    mainClassName: propStr(),
    onChangeKeyword: propFunc(),
    onChangeSearch: propFunc(),
    onClickGuestHeaderMenu: propFunc(),
    onSubmitSearch: propFunc(),
    renderStickyComponent: propChildren(),
    showFooter: propBool(),
    showHeader: propBool(),
    showProffitSearchLink: propBool(),
    showSearch: propBool(),
    sticky: propChildren(),
    stickyClassName: propStr(),
    type: propStr(),
};
Layout.defaultProps = {
    bottomContent: null,
    footerClassName: '',
    guestHeaderViewMode: 'normal',
    headerClassName: '',
    headerType: 'default',
    isHideHelp: false,
    isLoading: false,
    mainClassName: '',
    onChangeKeyword: undefined,
    onChangeSearch: undefined,
    onClickGuestHeaderMenu: undefined,
    onSubmitSearch: undefined,
    renderStickyComponent: undefined,
    showFooter: true,
    showHeader: true,
    showProffitSearchLink: true,
    showSearch: true,
    sticky: null,
    stickyClassName: '',
    type: '',
};
export default Layout;
